import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Tab,
  Tabs,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import PayPalCheckout from "./PayPalCheckout";
// import AirwallexCheckout from "./AirwallexCheckout"; // Temporarily disabled
import { useSnackbar } from "notistack";

const TopUpCredits = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [amount, setAmount] = useState(50);
  const [paymentMethod, setPaymentMethod] = useState("airwallex");

  const handleAmountChange = (e) => {
    const value = parseFloat(e.target.value);
    setAmount(isNaN(value) ? 0 : value);
  };

  const handlePaymentSuccess = (data) => {
    setSuccess(true);
    enqueueSnackbar(t("topUpCredits.successMessage"), { variant: "success" });
  };

  const handlePaymentError = (error) => {
    setError(error.message);
    enqueueSnackbar(t("topUpCredits.errorMessage"), { variant: "error" });
  };

  const handleContactSupport = () => {
    window.open("https://wa.me/16468280962", "_blank");
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 600, mx: "auto" }}>
        <Typography variant='h5' gutterBottom>
          {t("topUpCredits.title")}
        </Typography>
        {error && (
          <Alert severity='error' sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity='success' sx={{ mb: 2 }}>
            {t("topUpCredits.successMessage")}
          </Alert>
        )}
        <Tabs
          value={paymentMethod}
          onChange={(e, newValue) => setPaymentMethod(newValue)}
          sx={{ mb: 3 }}
        >
          {/* <Tab label={t("topUpCredits.airwallex")} value='airwallex' /> */}
          <Tab label="PayPal" value='paypal' />
          <Tab label={t("topUpCredits.contactSupport")} value='support' />
        </Tabs>

        {/* Airwallex Payment Method - Temporarily disabled until production account is activated */}
        {/* {paymentMethod === "airwallex" && (
          <>
            <TextField
              fullWidth
              label={t("topUpCredits.amount")}
              type='number'
              value={amount}
              onChange={handleAmountChange}
              InputProps={{
                startAdornment: (
                  <Box component='span' mr={1}>
                    $
                  </Box>
                ),
              }}
              variant='outlined'
              sx={{ mb: 2 }}
            />

            <Typography variant='body2' gutterBottom>
              {t("topUpCredits.minimumAmount", { amount: "$10" })}
            </Typography>

            <AirwallexCheckout
              amount={amount}
              onSuccess={handlePaymentSuccess}
              onError={handlePaymentError}
              onCancel={() => setError(t("topUpCredits.cancelledMessage"))}
            />
          </>
        )} */}

        {/* PayPal Payment Method */}
        {paymentMethod === "paypal" && (
          <>
            <TextField
              fullWidth
              label={t("topUpCredits.amount")}
              type='number'
              value={amount}
              onChange={handleAmountChange}
              InputProps={{
                startAdornment: (
                  <Box component='span' mr={1}>
                    $
                  </Box>
                ),
              }}
              variant='outlined'
              sx={{ mb: 2 }}
            />

            <Typography variant='body2' gutterBottom>
              {t("topUpCredits.minimumAmount", { amount: "$10" })}
            </Typography>

            <PayPalCheckout
              amount={amount}
              onSuccess={handlePaymentSuccess}
              onError={handlePaymentError}
              onCancel={() => setError(t("topUpCredits.cancelledMessage"))}
            />
          </>
        )}

        {/* Contact Support */}
        {paymentMethod === "support" && (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <Typography variant='body1' paragraph>
              {t("topUpCredits.contactSupportText")}
            </Typography>
            <Button variant='contained' onClick={handleContactSupport}>
              Whatsapp
            </Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default TopUpCredits;
